import { Company } from "./company.model"
import { User } from "./user.model"

export class SessionLog {
    public id?:number
    public username?: string
    public ipAddress?: string
    public browserName?: string
    public browserVersion?: string
    public userAgent?: string
    public date?: Date
    public companyId?: number
    public company?:Company
    public userId?: number
    public user?:User
}